<template>
    <!-- 分隔线组件 -->
    <el-divider 
    :direction="direction"
    :content-position="cntPosition"
    >
        <VelIcon :iconName="icon" :iconText="lineText" />
        <slot></slot>
    </el-divider>
</template>
<script>
import VelIcon from '../icon'
export default {
    name:"VelLine",
    components:{
        VelIcon
    },
    props:{
        direction:String,
        cntPosition:String,
        icon:String,
        lineText:String
    },
    data() {
        return {
            
        };
    },
}
</script>